import { useContext } from "react";
import { assert } from "~/utils/assert";
import { ToastContext } from "./ToastContext";

export function useToast() {
  const toast = useContext(ToastContext);
  assert(toast, "Using useToast without ToastProvider");
  return toast;
}
